export default __webpack_public_path__ + "static/media/Trade_Gothic_LT_Light.560089c1.ttf";